import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import IncidentTable from './IncidentTable';
import { SelectIncidentConfiguration, ToggleIncConfigDialog } from '../../../actions/IncidentTrackerConfigurationActions.js';

const IncidentGenericTypeTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();

	const _incConfigDialogOpen = (rowData, mode) => {
		const item = { id: rowData[0], genericType: rowData[1] };
		dispatch(SelectIncidentConfiguration({ category: 'genericType', item }));
		dispatch(ToggleIncConfigDialog(true, mode));
	};

	const _getTableColumns = () => (
		[
			{
				name: 'genericType',
				label: 'Generic Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<IncidentTable
			identifier="incidentGenericTypeTable"
			title="Generic Type"
			data={data}
			customColumns={_getTableColumns()}
			onDeleteClick={(rowData) => _incConfigDialogOpen(rowData, 'Delete')}
			onEditClick={(rowData) => _incConfigDialogOpen(rowData, 'Update')}
		/>
	);
};

IncidentGenericTypeTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default IncidentGenericTypeTable;
